// extracted by mini-css-extract-plugin
export default {"close":"close__Jx28","close-toast":"close-toast_3iE3H","closeToast":"close-toast_3iE3H","relative":"relative_1svo3","absolute":"absolute_3JwDh"};